import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';

export class TemplateUtenteAdapter {
  templateUtente: TemplateUtenteProfilo = new TemplateUtenteProfilo();
  constructor(templateUtente: TemplateUtenteProfilo) {
    if (templateUtente.id) {
      this.templateUtente.id = templateUtente.id;
    }
    this.templateUtente.label = templateUtente.label;
    this.templateUtente.templateProfiloGruppiOperativi = templateUtente.templateProfiloGruppiOperativi ? JSON.parse(JSON.stringify(templateUtente.templateProfiloGruppiOperativi)) : null;
    this.templateUtente.templateProfiloGruppiOrganizzativi = templateUtente.templateProfiloGruppiOrganizzativi ? JSON.parse(JSON.stringify(templateUtente.templateProfiloGruppiOrganizzativi)) : null;
    this.templateUtente.templateProfiloGruppiVisibilita = templateUtente.templateProfiloGruppiVisibilita ? JSON.parse(JSON.stringify(templateUtente.templateProfiloGruppiVisibilita)) : null;
    this.templateUtente.templateProfiloRuoli = templateUtente.templateProfiloRuoli ? JSON.parse(JSON.stringify(templateUtente.templateProfiloRuoli)) : null;
    this.templateUtente.templateProfiloPermessi = templateUtente.templateProfiloPermessi ? JSON.parse(JSON.stringify(templateUtente.templateProfiloPermessi)) : null;
    this.templateUtente.templateProfiloGruppiSpeciali = templateUtente.templateProfiloGruppiSpeciali ? JSON.parse(JSON.stringify(templateUtente.templateProfiloGruppiSpeciali)) : null;
    this.templateUtente.permessiPerGruppoOrganizzativo = templateUtente.permessiPerGruppoOrganizzativo ? JSON.parse(JSON.stringify(templateUtente.permessiPerGruppoOrganizzativo)) : null; 

    this.templateUtente.templateProfiloGruppiOperativi.sort((leftSide, rigthSide): number => {
      if (leftSide.label < rigthSide.label) return -1;
      if (leftSide.label > rigthSide.label) return 1;
      return 0;
    });

    this.templateUtente.templateProfiloGruppiOrganizzativi.sort((leftSide, rigthSide): number => {
      if (leftSide.label < rigthSide.label) return -1;
      if (leftSide.label > rigthSide.label) return 1;
      return 0;
    });

    this.templateUtente.templateProfiloGruppiVisibilita.sort((leftSide, rigthSide): number => {
      if (leftSide.label < rigthSide.label) return -1;
      if (leftSide.label > rigthSide.label) return 1;
      return 0;
    });


    this.templateUtente.templateProfiloRuoli.sort((leftSide, rigthSide): number => {
      if (leftSide.label < rigthSide.label) return -1;
      if (leftSide.label > rigthSide.label) return 1;
      return 0;
    });

    this.templateUtente.templateProfiloPermessi.sort((leftSide, rigthSide): number => {
      if (leftSide.label < rigthSide.label) return -1;
      if (leftSide.label > rigthSide.label) return 1;
      return 0;
    });

//    this.templateUtente.templateProfiloGruppiSpeciali.sort((leftSide, rigthSide): number => {
//      if (leftSide.label < rigthSide.label) return -1;
//      if (leftSide.label > rigthSide.label) return 1;
//      return 0;
//    });
  }



}
